import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";
export default function CommercialExcellence() {
  return <section data-section-id="241217" id="commercial-excellence" className="bg-background text-foreground relative w-full py-24 md:py-32 flex items-center justify-center min-h-[70vh] overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/70 z-10"></div>
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688421/img/luxury_commercial_building_exterior.png)] z-0 scale-105 transition-transform duration-1000 hover:scale-100"></div>
      </div>

      {}
      <div className="relative z-20 p-10 bg-black/40 backdrop-blur-[12px] border border-white/10 flex flex-col items-center text-center max-w-2xl mx-4 shadow-3xl">
        <div className="mb-4 opacity-90">
          <Compass className="w-10 h-10 text-primary" strokeWidth={1} />
        </div>
        
        <h2 className="font-default text-4xl md:text-5xl font-bold mb-6 text-white tracking-tighter uppercase">
          Commercial Precision
        </h2>
        
        <p className="font-default text-lg md:text-xl text-white/80 mb-10 max-w-md leading-relaxed font-light">
          Elite window cleaning for GTA businesses. Fully insured, reliable scheduling, and a professional appearance for your low-rise commercial property.
        </p>
        
        <Button asChild size="lg" className="px-8 py-6 text-lg rounded-md shadow-xl bg-white text-black hover:bg-white/90 transition-all duration-300">
          <Link to="/HomePage">
            Request Commercial Quote
          </Link>
        </Button>
      </div>
    </section>;
}